export default __webpack_public_path__ + "static/media/chat_logo.1f7c2123.png";